import { StyleSheet } from 'aphrodite'

const styles = StyleSheet.create({
  latest: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '40px',
    width: 950,
    display: 'flex',
    flexDirection: 'column'
  },
  headline: {
    fontWeight: 'bold',
    fontSize: '14px',
    alignSelf: 'flex-start',
    marginLeft: 10
  },
  mediaWrapper: {
    display: 'flex'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/StartPage/Latest/styles.js